import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export type DeactivateUserParams = {
  userId: string;
  hideArticles: boolean;
};

export const deactivateUser = async ({ userId, hideArticles }: DeactivateUserParams) => {
  const [response, bodyOrError] = await Api.patch(`users/${userId}/deactivate-user`, { hideArticles });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeactivateUser = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'deactivateUser',
    (data: DeactivateUserParams) => {
      return deactivateUser(data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getReportedUserById']);
        queryClient.invalidateQueries('reportedUsers');
        queryClient.invalidateQueries('getUsersByPage');
        queryClient.invalidateQueries('getUsersCount');
      },
    },
  );
};

// Retained for callers that deactivated users only from the reported-user screen.
export const useDeactivateReportedUser = useDeactivateUser;
